import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScormService {
  readonly rootURL = environment.ImpataAppAPIRoot;

  constructor(private http: HttpClient,) { }

  async UploadScormFile(data: any) {
    return this.http
      .post(this.rootURL + `scorm/importscorm`, data, {
        headers: new HttpHeaders({
          'Content-Disposition': 'multipart/form-data',
        }),
      })
      .toPromise();
  }
}
